/** @file The display pivot in image px: half pixels, halfPixel +0.5 x on the unflipped tile, then mirrored. */

/**
 * `snap 'pixel'` rounds each component to 0.5 px; `halfPixel` adds 0.5 to x on the unflipped tile (the pivot pixel's
 * centre, 21.6: "with halfPixel already added"); `flip` then mirrors that x to `texW - x`, so a flipped tile is the exact
 * mirror image of the unflipped one about the node (pivot pixel 4 of an 8 px tile mirrors to pixel 3: 4.5 -> 3.5).
 */
export function displayPivot(pickPivot: [number, number], texW: number, flip: boolean, snap: 'pixel' | 'none', halfPixel: boolean): [number, number] {
  const [px, py] = snap === 'pixel' ? [Math.round(pickPivot[0] * 2) / 2, Math.round(pickPivot[1] * 2) / 2] : pickPivot;
  const x = halfPixel ? px + 0.5 : px;
  return [flip ? texW - x : x, py];
}
